import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState('');

    // --- Initialize EmailJS on Mount ---
    useEffect(() => {
        if (process.env.REACT_APP_EMAILJS_PUBLIC_KEY) {
            emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError('');

        if (!name || !email || !message) {
            setSubmitError('All fields are required');
            setIsSubmitting(false);
            setTimeout(() => setSubmitError(''), 5000);
            return;
        }

        const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
        const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
        const recipientEmail = process.env.REACT_APP_RECIPIENT_EMAIL;

        if (!serviceId || !templateId) {
            setSubmitError('Email service is not configured.');
            setIsSubmitting(false);
            return;
        }

        const templateParams = {
            name: name,
            email: email,
            message: message,
            to_email: recipientEmail,
            reply_to: email,
            subject: `Consulting inquiry from ${name}`
        };

        try {
            await emailjs.send(serviceId, templateId, templateParams);
            setSubmitSuccess(true);
            setIsSubmitting(false);
            setName('');
            setEmail('');
            setMessage('');
            setTimeout(() => setSubmitSuccess(false), 3000);
        } catch (error) {
            console.error('Failed to send email:', error);
            setSubmitError('Failed to send email. Please try again later.');
            setIsSubmitting(false);
            setTimeout(() => setSubmitError(''), 5000);
        }
    };

    return (
        <section id="contact">
            <div className="contact-left">
                <h2>Contact Us</h2>
            </div>
            <div className="contact-right">
                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="name"><span className="status-indicator"></span>Name</label>
                        <input type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="email"><span className="status-indicator"></span>Email</label>
                        <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="message"><span className="status-indicator"></span>Message</label>
                        <textarea id="message" name="message" rows="4" value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
                    </div>

                    {submitError && <div className="error-message">{submitError}</div>}
                    
                    <button type="submit" disabled={isSubmitting || submitSuccess}>
                        {isSubmitting ? 'Sending...' : submitSuccess ? 'Sent!' : 'Send Inquiry'}
                    </button>
                </form>
            </div>
        </section>
    );
};

export default Contact; 